export enum VehicleStatus {
    DRAFT = 'DRAFT',
    ELIGIBLE = 'ELIGIBLE',
    NON_ELIGIBLE = 'NON_ELIGIBLE',
    ENROLLED = 'ENROLLED',
    FAILED_TOKEN_EXCHANGE = 'FAILED_TOKEN_EXCHANGE',
    TELEMETRY_PENDING = 'TELEMETRY_PENDING',
    TELEMETRY_ACTIVE = 'TELEMETRY_ACTIVE',
    TELEMETRY_FAILED = 'TELEMETRY_FAILED',
}
